import { IconButton } from '@/components';
import { goBackSafe } from '@/utils';
import type { FC, ReactNode } from 'react';

/**
 * @description legacy for v3
 */
export const ReturnWrapper: FC<{ title: string; children: ReactNode }> = (
  props,
) => {
  // props
  const { title, children } = props;
  return (
    <>
      <header className="sticky top-0 z-10 h-15 flex gap-2 items-center px-6 bg-white">
        <IconButton
          className="text-base"
          iconType="icon-fanhui"
          onClick={() => goBackSafe()}
        />
        <p className="text-sm text-main">{title}</p>
      </header>
      {children}
    </>
  );
};
